export default {
  namespaced: true,
  state: {
    locale: localStorage.getItem('locale') || 'ar',
  },
  getters: {
    getLocale(state) {
      return state.locale
    },
  },
  mutations: {
    setLocale(state, val) {
      state.locale = val
      localStorage.setItem('locale', val)
    },
  },
  actions: {},
}
